var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4013 12.3971C15.516 11.9514 15.9703 11.6831 16.416 11.7978C18.213 12.2603 19.5417 13.8905 19.5417 15.8332V17.4998C19.5417 17.9601 19.1686 18.3332 18.7083 18.3332C18.2481 18.3332 17.875 17.9601 17.875 17.4998V15.8332C17.875 14.6694 17.0791 13.6895 16.0006 13.4119C15.5549 13.2972 15.2866 12.8428 15.4013 12.3971Z",
    fill: "#6C737F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5192 2.42946C12.6919 2.00285 13.1777 1.797 13.6043 1.96969C15.1298 2.58718 16.2083 4.08322 16.2083 5.83317C16.2083 7.58312 15.1298 9.07916 13.6043 9.69665C13.1777 9.86934 12.6919 9.6635 12.5192 9.23688C12.3465 8.81027 12.5524 8.32445 12.979 8.15176C13.8967 7.78027 14.5417 6.88104 14.5417 5.83317C14.5417 4.7853 13.8967 3.88607 12.979 3.51458C12.5524 3.3419 12.3465 2.85607 12.5192 2.42946Z",
    fill: "#6C737F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35745 11.6665C7.64693 11.6669 8.93641 11.6669 10.2259 11.6665C11.1347 11.6662 11.7549 11.666 12.2867 11.8085C13.7246 12.1938 14.8477 13.3169 15.233 14.7548C15.4249 15.4708 15.3693 16.2362 15.3751 16.9699C15.3759 17.059 15.3773 17.2392 15.3324 17.4067C15.2168 17.8381 14.8799 18.175 14.4485 18.2906C14.281 18.3355 14.1008 18.334 14.0117 18.3333C10.1992 18.3029 6.3841 18.3029 2.57159 18.3333C2.4825 18.334 2.30232 18.3355 2.13481 18.2906C1.70344 18.175 1.36651 17.8381 1.25093 17.4067C1.20604 17.2392 1.20748 17.059 1.20819 16.9699C1.21402 16.238 1.15874 15.4697 1.35031 14.7548C1.73559 13.3169 2.8587 12.1938 4.29659 11.8085C4.82843 11.666 5.4486 11.6662 6.35745 11.6665Z",
    fill: "#6C737F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 5.83317C4.125 3.53198 5.99048 1.6665 8.29167 1.6665C10.5929 1.6665 12.4583 3.53198 12.4583 5.83317C12.4583 8.13436 10.5929 9.99984 8.29167 9.99984C5.99048 9.99984 4.125 8.13436 4.125 5.83317Z",
    fill: "#6C737F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4f6b372fb585fdd9d71ed056bc39ca71.svg";
export { ForwardRef as ReactComponent };